import React, { useState, useEffect, useRef } from "react";
import { FaGamepad, FaUser, FaChartBar } from "react-icons/fa";
import "./BottomBar.css";

const BottomBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setIsVisible(false); // Hide when scrolling down
      } else if (currentScrollY < lastScrollY.current) {
        setIsVisible(true); // Show when scrolling up
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigate = (path) => {
    window.location.href = path;
  };

  return (
    <div className={`bottom-bar ${isVisible ? "visible" : "hidden"}`}>
      <div className="bottom-bar-content">
        <button 
          className="nav-button" 
          onClick={() => navigate("/dashboard")}
          aria-label="Dashboard"
        >
          <div className="icon-circle">
            <FaGamepad className="icon" />
          </div>
          <span className="nav-label">Play</span>
        </button>

        <button 
          className="nav-button" 
          onClick={() => navigate("/leadbd")}
          aria-label="Leaderboard"
        >
          <div className="icon-circle">
            <FaChartBar className="icon" />
          </div>
          <span className="nav-label">Stats</span>
        </button>

        <button 
          className="nav-button" 
          onClick={() => navigate("/me")}
          aria-label="Profile"
        >
          <div className="icon-circle">
            <FaUser className="icon" />
          </div>
          <span className="nav-label">Profile</span>
        </button>
      </div>
    </div>
  );
};

export default BottomBar;